// extracted by mini-css-extract-plugin
var _1 = "ChCxi";
var _2 = "FgZCu";
export { _1 as "base", _2 as "otherSection" }
